import Vue from 'vue'
import { login, getPermissionsRoutes, logout, modifyPassword } from '@/webpublicapi/login'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import cookie from '../../utils/cookie'
import CONST_REQUEST from '../../constants/request'

const user = {
  state: {
    token: '',
    name: localStorage.getItem('userName') || '',
    welcome: '',
    userId: localStorage.getItem('userId') || '',
    avatar: localStorage.getItem('avatarUrl') || "/9.png",
    roles: [],
    menus: [],
    crossBorder: false,
    info: {}
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome, userId }) => {
      localStorage.setItem('userName', name)
      localStorage.setItem('userId', userId)
      state.name = name
      state.welcome = welcome
      state.userId = userId
    },
    SET_AVATAR: (state, avatar) => {
      localStorage.setItem('avatarUrl', avatar)
      state.avatar = avatar
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
      // state.menus = []

    },
    SET_CROSS_BORDER: (state, crossBorder) => {
      state.crossBorder = crossBorder
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    }
  },

  actions: {
    // Login
    Login({ commit }, userInfo) {
      return login(userInfo).then(res => {
        const data = res.data || {}
        if (res.code == CONST_REQUEST.CODE_SUCCESS) {
          cookie.set('token', data.token)
          commit('SET_TOKEN', data.token)
          commit('SET_NAME', { name: data.userName, userId: data.userId, welcome: welcome() })
          // commit('SET_AVATAR', "http://8.140.147.56/static/adv.jpg")
          commit('SET_AVATAR', "/9.png")
          localStorage.setItem('avatarUrl', "/9.png")
        } else {
          throw new Error(res.msg)
        }
        return res
      }).catch(e => {
        throw e
      })
    },

    // Get user info
    GetInfo({ commit }) {
      return getPermissionsRoutes().then(res => {
        // console.log(666666666, res.data)
        // res.data.menus.forEach(item => {
        //     item.nameEs = "nameEs"
        //     item.nameAr = "nameAr"
        //     item.nameFr = "nameFr "
        // })
        // console.log(77777777, res.data)
        const data = res.data || {}
        if (res.code == CONST_REQUEST.CODE_SUCCESS) {
          commit('SET_MENUS', data.menus || [])
          commit('SET_CROSS_BORDER', data.crossBorder || false)
        } else {
          throw new Error(res.msg)
        }
        return res
      }).catch(e => {
        throw e
      })
    },

    // Clear user info
    clearUserInfo({ commit }) {
      commit('SET_MENUS', [])
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
    },


    // Logout
    Logout({ commit, state }) {
      return new Promise((resolve) => {
        logout(state.token).then(() => {
          cookie.delete('token')
          resolve()
        }).catch(e => {
          throw new Error(e.message)
        }).finally(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          commit('SET_MENUS', [])
          // cookie.delete('token');
        })
      })
    },

    // Logout
    LogoutV1({ commit, state }) {
      return new Promise((resolve) => {
        cookie.delete('token')
        resolve()
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_MENUS', [])
      })
    },

    modifyPassword({ commit }, params) {
      return modifyPassword(params).then((res) => {
        if (res.code == CONST_REQUEST.CODE_SUCCESS) {
          return res
        } else {
          throw new Error(res.msg)
        }
      })
    }

  }
}

export default user